module.exports = __webpack_public_path__ + "img/GH-kyujin-jimu001.c70968ea.webp";